module.exports = __webpack_public_path__ + "img/join_icon.c0891222.svg";